// extracted by mini-css-extract-plugin
export default {"form":"EditUserModal_form__Ytuy7"};